import { db } from "@/api/firebase";
import { City } from "@/models/City";
import { QuestError } from "@/models/Errors/QuestError";
import { Quests } from "@/models/MapPois/Quest/Quests";
import {
  Q_QUEST_STATUS,
  Q_QUEST_TYPE,
} from "@/models/MapPois/Quest/QuestsEnum";
import { isEmpty } from "lodash";

export default class QuestMapError {
  questData: Quests;
  gameUid: string;
  errorObject = {} as QuestError;
  constructor(gameUid: string, questData: Quests) {
    this.questData = questData;
    this.gameUid = gameUid;
  }

  checkQuestErrors(): QuestError {
    this.isGeneralTitleEmpty();
    this.isGeneralDescEmpty();
    this.doesActiveHaveExit();
    this.doesFinalHasGameStatus();
    if (!isEmpty(this.errorObject)) {
      db.ref(
        "quests/" + this.gameUid + "/" + this.questData.key + "/issues/err/"
      ).set(this.errorObject);
    } else {
      db.ref(
        "quests/" + this.gameUid + "/" + this.questData.key + "/issues/err/"
      ).remove();
    }
    return this.errorObject;
  }

  private isGeneralTitleEmpty(): void {
    if (this.questData.title.en.trim().length == 0) {
      this.errorObject.no_title = {
        active: true,
        txt: {
          en: "General: Title Missing",
        },
      };
    }
  }
  private isGeneralDescEmpty(): void {
    if (this.questData.desc.en.trim().length == 0) {
      this.errorObject.no_desc = {
        active: true,
        txt: {
          en: "General: Description Missing",
        },
      };
    }
  }

  private doesActiveHaveExit(): void {
    if (
      this.questData.statusGoals[Q_QUEST_STATUS.ACTIVE].exitGoals === undefined
    ) {
      this.errorObject.no_active_exit_goal = {
        active: true,
        txt: {
          en: "Status Active: No Exit Goal",
        },
      };
    }
  }

  private doesFinalHasGameStatus(): void {
    if (
      this.questData.type == Q_QUEST_TYPE.MAIN &&
      this.questData.statusGoals[Q_QUEST_STATUS.FINAL].actions
        ?.gameStatusAction === undefined
    ) {
      this.errorObject.no_final_game_status = {
        active: true,
        txt: {
          en: "Main - Status Final: No Game Status Action",
        },
      };
    }
  }
}
